module.exports = __webpack_public_path__ + "static/sport/swiper-4.fe9742c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/swiper-4.png
// module id = 9T50
// module chunks = 0